import { NETWORK_ERROR_MESSAGE, UNAUTHORIZED_MESSAGE, toUserMessage } from '@/utils/error';

/**
 * Message for figures that failed to load. Network and permission problems get
 * their own plain wording; anything else says what failed and to try again —
 * never raw server text.
 */
export function loadErrorMessage(what: string, error?: unknown): string {
  const fallback = `We couldn't load ${what}. Please try again.`;
  if (!error) return fallback;
  const message = toUserMessage(error, fallback);
  return message === NETWORK_ERROR_MESSAGE || message === UNAUTHORIZED_MESSAGE ? message : fallback;
}
